<div class="form__block">
  <div class="heading heading_standard heading_centered">
    Account information
  </div>
  <div class="fields">
    <div
      class="fields__item fields__item_full"
      [appIfInvalid]="nameFC"
      [validationErrors]="{
        required: 'Please, enter name',
      }"
    >
      <input
        [formControl]="nameFC"
        type="text"
        placeholder=""
        maxlength="50"
        autocomplete="given-name"
        id="name"
      />
      <label for="name">Name</label>
      <ng-template [appErrorsHost] />
    </div>

    <div
      class="fields__item fields__item_full"
      [appIfInvalid]="surnameFC"
      [validationErrors]="{
        required: 'Please, enter surname',
      }"
    >
      <input
        [formControl]="surnameFC"
        type="text"
        placeholder=""
        maxlength="50"
        autocomplete="family-name"
        id="surname"
      />
      <label for="surname">Surname</label>
      <ng-template [appErrorsHost] />
    </div>

    <div class="fields__item fields__item_full">
      <input type="text" id="e-mail" [value]="userEmail$ | async" readonly />
      <label for="e-mail">E-mail</label>
    </div>

    <div
      class="fields__item fields__item_full"
      [appIfInvalid]="phoneFC"
      [validationErrors]="{
        required: 'Please, enter phone',
      }"
    >
      <input
        [formControl]="phoneFC"
        type="text"
        placeholder=""
        maxlength="20"
        autocomplete="tel"
        id="phone"
      />
      <label for="phone">Phone</label>
      <ng-template [appErrorsHost] />
    </div>
  </div>
</div>
